module.exports = __webpack_public_path__ + "static/media/workshop.27a77e0c.svg";